export const buildBeforeRouteChange = data => ({
  type: 'BUILD_BEFORE_ROUTE_CHANGE_ACTION',
  payload: { data },
});
